import { verifyToken } from '@/utilities/jwt';
import Cookies from 'js-cookie';
import IToken from './IToken';

export async function doLogin(token: string): Promise<IToken> {
    const decodedToken: IToken = await verifyToken(token);

    localStorage.setItem('decodedToken', JSON.stringify(decodedToken));

    Cookies.set('token', token, {
        domain: process.env.TOKEN_COOKIE_DOMAIN,
    });

    return decodedToken;
}

export function doLogout(): void {
    localStorage.removeItem('decodedToken');

    Cookies.remove('token', {
        domain: process.env.TOKEN_COOKIE_DOMAIN,
    });
}

